import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {ButtonComponent} from "../../../shared-module/components/button/button.component";
import {ModalRef} from "../../../shared-module/services/modal.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-password-reset-confirm-modal',
    imports: [
        ButtonComponent,
    ],
    templateUrl: './password-reset-confirm-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './password-reset-confirm-modal.component.scss'
})
export class PasswordResetConfirmModalComponent {
  readonly modalRef: ModalRef<PasswordResetConfirmModalComponent> = inject<ModalRef<PasswordResetConfirmModalComponent>>(ModalRef);
  readonly router: Router = inject(Router);

  public close() {
    this.modalRef.cancel();

    this.router.navigate(['/login']);
  }
}
